import debounce from "lodash.debounce";
import { useEffect, useReducer } from "react";

import { getClient } from "../client";
import { flattenRawUser } from "../entities/users";
import { connectedAsUser } from "../state";

const debouncer = debounce((f) => f(), 500); // after 500ms

const initialState = { loading: false, error: null, users: [] };

function reducer(state, action) {
  switch (action.type) {
    case "AUTOCOMPLETE_LOADING":
      return { ...state, loading: true, error: null };
    case "AUTOCOMPLETE_RESPONSE":
      return {
        loading: false,
        error: action.error || null,
        users: action.users || [],
      };
    default:
      // eslint-disable-next-line no-console
      console.error(
        `useAutoCompleteUsers reducer does not support type: '${action.type}'`
      );
      return state;
  }
}

export default function useAutoCompleteUsers({ input }) {
  const { community } = connectedAsUser.use();
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    try {
      if (input) {
        dispatch({ type: "AUTOCOMPLETE_LOADING" });
        debouncer(async () => {
          const { users: matchingUsers } = await getClient().queryUsers({
            name: { $autocomplete: input },
            community,
            active: true,
          });
          const flattendUsers = matchingUsers.map(flattenRawUser);
          dispatch({ type: "AUTOCOMPLETE_RESPONSE", users: flattendUsers });
        });
      } else {
        // clear out users when empty string is passed
        dispatch({ type: "AUTOCOMPLETE_RESPONSE", users: [] });
      }
    } catch (e) {
      dispatch({ type: "AUTOCOMPLETE_RESPONSE", error: e.message });
    }
  }, [community, input]);

  return state;
}
